import schema from '../CadastrarUsuario/schema';

import { cloneObject } from '../../../../utils';

export default function translateToSchema({
    contractList,
    dataUser,
    contractNumber,
    dataActiveContract,
    profileUser = { permissoes: [] },
}) {
    const clonedSchema = cloneObject(schema);

    const isAdmin = profileUser.permissoes.find(({ id }) => +id === 8);

    clonedSchema.contracts.value = contractNumber;
    clonedSchema.contracts.options = contractList;
    clonedSchema.email.value = dataUser.emailContato;
    clonedSchema.fullName.value = dataUser.nomeContato;
    clonedSchema.cellphone.value = `(${dataUser.dddCelular}) ${dataUser.numeroCelular}`;
    clonedSchema.cellphone.unmaskedValue = `(${dataUser.dddCelular}) ${dataUser.numeroCelular?.replace('-', '')}`;
    if (dataUser.dataNascimentoContato) {
        clonedSchema.birth.value = dataUser.dataNascimentoContato;
    }
    clonedSchema.typeUser.value = isAdmin ? 'RH' : 'MCE';
    clonedSchema.position.value = dataUser.nomeCargoContato;
    clonedSchema.permissions.value = profileUser.permissoes.map(({ id }) => id);
    clonedSchema.permissions.options = dataActiveContract.isSpecificContract
        ? clonedSchema.permissions.options.filter(({ codigo }) => ['1', '4'].includes(codigo.toString()))
        : clonedSchema.permissions.options;

    return clonedSchema;
}
